import gql from 'graphql-tag';

export const DetailsPanelContentLabelsQuery = gql`
	query DetailsPanelContentLabelsQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
				count
				nodes {
					id
					label
					name
					prefix
				}
			}
		}
		content(id: $contentId) {
			nodes {
				type
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
